
const pricingQuestions = [
  'How is the transport cost calculated on Shahen’s platform?',
  'Is VAT applied to transport invoices?',
  'Is billing issued per trip or as a consolidated master invoice?',
  'Can invoices be segmented by branch, city, or cargo type?',
  'Are there cancellation fees for transport orders?',
  'Are there fees for driver delays or overnight stays?',
  'Can the company wallet be linked to the billing system?',
  'Does Shahen offer postpaid payment options for businesses?',
  'What payment methods are available on Shahen’s platform?',
];

const pricingAnswers = [
  'The cost is automatically calculated based on the distance between pickup and delivery points and the selected truck type. For companies with fixed routes or recurring demand, Shahen offers long-term contract pricing to ensure cost stability and operational predictability.',
  'Yes, all Shahen invoices include 15% VAT and are fully compliant with ZATCA e-invoicing standards.',
  'Billing depends on the client’s contract type. For postpaid clients, Shahen issues a consolidated master invoice covering all trips within the agreed credit period. For standard clients, an individual invoice is issued for each completed trip.',
  'Yes, invoices can be segmented based on the client’s needs — by branch, city, or cargo category. For example, a company may receive separate consolidated invoices for each branch (Dammam, Jeddah, Riyadh) or separate invoices for transporting raw materials versus finished goods or showroom deliveries.',
  'Yes, cancellation fees apply according to the terms and conditions stated in Shahen’s service policy.',
  'Yes, additional fees apply for delays or overnight stays, depending on truck type and duration, as stated in the platform’s terms and conditions.',
  'Yes, the client’s wallet can be integrated with Shahen’s billing system so that trip payments are automatically deducted from the available balance.',
  'Yes, eligible companies can access postpaid payment options under formal contracts, based on order volume and operational consistency.',
  'Shahen supports multiple payment methods including bank transfers, Mada, Visa, MasterCard, Apple Pay, STC Pay, and preloaded corporate wallet payments.',
];

const transportQuestions = [
  'What types of trucks are available through Shahen?',
  'Does Shahen provide port and container transport services?',
  'Does Shahen offer cross-border land transport services?',
  'Does Shahen transport small parcels, personal items, or cargo by weight?',
  'Can a single trip include multiple pickup or delivery points?',
  'Can I add multiple pickup sites?',
  'Can loading or delivery be scheduled on Fridays or outside business hours?',
];
const transportAnswers = [
  'Shahen provides a wide range of truck types, including trailers, six-wheelers, lorries, dainas, and pickups — available in various configurations (flatbed, curtain-side, reefer, high-side, German-side) to meet all corporate logistics needs.',
  'Yes, Shahen manages container and cargo transport to and from Saudi ports, including customs coordination and on-time delivery management.',
  'Shahen provides cross-border land transport to neighboring countries under full regulatory and insurance compliance, ensuring smooth and reliable export and import operations.',
  'Shahen provides full-truckload (FTL) transport only, where a complete truck is dedicated to the client’s shipment. Partial-load, weight-based, or personal-item transport services are not offered.',
  'Yes, multi-stop trips are available based on client needs, and pricing is calculated automatically according to total distance and number of stops.',
  'Yes, clients can add multiple pickup/delivery locations.',
  'Yes, shipments can be handled outside standard working hours, including Fridays, with prior coordination or under a special service agreement.',
];

const businessAndContractsQuestions = [
  'Can businesses sign long-term transport contracts with Shahen?',
  'Can Shahen assign an onsite logistics coordinator at our facility?',
  'Can Shahen assign an employee to manage transport operations onsite?',
  'What are the responsibilities of the assigned corporate account manager?',
  'We have a high daily order volume — is there an easier way to submit requests?',
];

const businessAndContractsAnswers = [
  'Yes, Shahen offers annual and semi-annual long-term transport contracts that guarantee truck availability, fixed pricing, and consistent performance across all routes.',
  'Yes, Shahen offers this service for clients with high or recurring shipment volumes by assigning an onsite logistics coordinator to manage daily truck movements and oversee loading and unloading.',
  'Yes, Shahen can assign an onsite logistics coordinator for clients with high or recurring shipment volumes to manage scheduling and oversee daily operations.',
  'The account manager handles order submissions on behalf of the client, schedules transport routes, monitors truck movements, provides performance and billing reports, and ensures continuous support and communication 24/7.',
  'Yes, clients can share their daily shipment schedule with their account manager to handle submissions on their behalf, or integrate their ERP system with Shahen for automated order uploads.',
];

const shipmentAndTrackingQuestions = [
  'How can companies track their shipments?',
  'Can clients track drivers in real-time via map view?',
  'Can I track historical and completed transport orders?',
  'Can transport requests be scheduled in advance?',
  'Can an order be modified or cancelled after submission?',
  'Is a request submitted through the app or website automatically confirmed?',
  'Can the original delivery note be returned after being signed and stamped by the receiver?',
  'Can I obtain digital copies of pickup and delivery notes?',
];

const shipmentAndTrackingAnswers = [
  'Companies can track their shipments and trucks in real-time through the platform or app, receiving instant status updates for full operational visibility.',
  'Yes, Shahen’s live map feature allows real-time driver tracking with status updates and estimated arrival times.',
  'Yes, clients can view and download records of all completed or archived transport orders from their Shahen dashboard.',
  'Yes, clients can pre-schedule future trips to ensure truck availability and smoother logistics planning.',
  'Yes, orders can be modified or cancelled before dispatch according to Shahen’s terms and conditions; partial executions may incur applicable fees.',
  'Yes, all transport requests submitted through the platform are automatically confirmed and processed immediately by Shahen’s operations team.',
  'Yes, the original signed delivery note can be returned to the client upon request, coordinated through the assigned account manager or customer service.',
  'Yes, clients can download digital copies of pickup and delivery notes directly from the dashboard or through their account manager.',
];

const accountAndAccessQuestions = [
  'I opened an individual account instead of a business account — can it be changed?',
  'Can different users within my company have separate access permissions?',
];
const accountAndAccessAnswers = [
  'Yes, your account type can be changed to a business account by contacting Shahen’s support team through the official support channels.',
  'Yes, Shahen allows assigning role-based access permissions for multiple users within one corporate account — e.g., order creation, invoice review, or reporting only.',
];

const platformAndIntegrationQuestions = [
  'Can our company’s ERP system be integrated with Shahen?',
  'How can transport requests be submitted through Shahen’s platform?',
];

const platformAndIntegrationAnswers = [
  'Yes, Shahen enables full API integration with client ERP or SAP systems, allowing automated order placement, shipment tracking, and invoice synchronization.',
  'Clients can submit requests directly through the Shahen app or website, or via their assigned account manager or the corporate customer service team.',
];

const reportingAndInsightsQuestions = [
  'Does Shahen provide operational or financial reporting for clients?',
  'Can Shahen provide monthly operational and billing reports?',
  'Can we receive a monthly report listing delivery note numbers along with the invoice?',
  'Does Shahen provide performance reports by branch?',
];

const reportingAndInsightsAnswers = [
  'Yes, companies can access operational, financial, and invoice reports directly through their Shahen dashboard for precise performance monitoring.',
  'Yes, Shahen can generate detailed monthly reports including total trips, operating routes, truck types, and invoiced amounts to help clients monitor performance accurately.',
  'Yes, Shahen can provide a detailed report including all delivery note numbers for completed trips within the invoicing period, attached to the consolidated invoice.',
  'Yes, Shahen can generate separate performance and billing reports for each company branch, enabling accurate financial tracking and strategic planning.',
];

const policiesAndRegulationsQuestions = [
  'What is the maximum waiting time for loading or unloading at client sites?',
  'What is Shahen’s policy in case of cargo damage or loss?',
  'Are shipments insured when transported through Shahen?',
  'Can a specific driver nationality be requested for access to sensitive or government sites?',
  'Does Shahen issue an official transport document for each trip?',
  'Are my company data and shipment information protected?',
  'Is Shahen licensed by the Transport General Authority?',
];

const policiesAndRegulationsAnswers = [
  'Shahen allows standard waiting times within the service rate, with extended waiting available at additional cost billed post-delivery, based on truck type and duration.',
  'In case of cargo damage or loss, a formal claim is filed under the insurance terms, and compensation is processed based on the declared insured value.',
  'Yes, all shipments through Shahen are insured based on their declared value, with digital documentation of loading and delivery proofs to ensure transparency and accountability.',
  'Yes, specific driver nationalities can be arranged upon request, based on the security or access requirements of client facilities.',
  'Yes, Shahen issues an official electronic transport document for every trip through the “Logisti” platform under the Transport General Authority.',
  'Yes, Shahen ensures full confidentiality of all client data and transport information through advanced security protocols. Data privacy is a core operational commitment.',
  'Yes, Shahen is officially licensed by the Transport General Authority under license number 29/00000747, operating in full compliance with Saudi transport regulations.',
];

const companyInfoQuestions = ['Who owns Shahen?'];

const companyInfoAnswers = [
  'Shahen is owned by Fikr for Communications & Information Technology, a licensed Saudi company specializing in digital transport and logistics solutions.',
];

export const _faqsEnSupport = {
  pricingAndBilling: pricingQuestions.map((question, i) => ({
    id: new Date().getTime() + i, // generate unique ID
    question,
    answer: pricingAnswers[i],
  })),
  transportServices: transportQuestions.map((question, i) => ({
    id: new Date().getTime() + i + 10, // add offset so IDs stay unique
    question,
    answer: transportAnswers[i],
  })),
  businessAndContracts: businessAndContractsQuestions.map((question, i) => ({
    id: new Date().getTime() + i + 20,
    question,
    answer: businessAndContractsAnswers[i],
  })),
  shipmentAndTracking: shipmentAndTrackingQuestions.map((question, i) => ({
    id: new Date().getTime() + i + 30,
    question,
    answer: shipmentAndTrackingAnswers[i],
  })),
  accountAndAccess: accountAndAccessQuestions.map((question, i) => ({
    id: new Date().getTime() + i + 40,
    question,
    answer: accountAndAccessAnswers[i],
  })),
  platformAndIntegration: platformAndIntegrationQuestions.map((question, i) => ({
    id: new Date().getTime() + i + 50,
    question,
    answer: platformAndIntegrationAnswers[i],
  })),
  reportingAndInsights: reportingAndInsightsQuestions.map((question, i) => ({
    id: new Date().getTime() + i + 60,
    question,
    answer: reportingAndInsightsAnswers[i],
  })),
  policiesAndRegulations: policiesAndRegulationsQuestions.map((question, i) => ({
    id: new Date().getTime() + i + 70,
    question,
    answer: policiesAndRegulationsAnswers[i],
  })),
  companyInfo: companyInfoQuestions.map((question, i) => ({
    id: new Date().getTime() + i + 80,
    question,
    answer: companyInfoAnswers[i],
  })),
};
